import { render } from "./SubscriptionSuccess.vue?vue&type=template&id=781cb918&scoped=true"
import script from "./SubscriptionSuccess.vue?vue&type=script&lang=js"
export * from "./SubscriptionSuccess.vue?vue&type=script&lang=js"

import "./SubscriptionSuccess.vue?vue&type=style&index=0&id=781cb918&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781cb918"]])

export default __exports__